export default "__VITE_ASSET__6lXaef5i__"